module.exports = __webpack_public_path__ + "static/media/ic_categories_baby_stuff.5cf9b8e4.svg";